import {
    Component,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges
} from '@angular/core';
import moment from 'moment';
import { ReplaySubject } from 'rxjs';
import { IInvoiceCycle } from '../../../contract-management/IInvoiceCycle';
import { InvoiceContractCycleModel } from '../../../data-services/invoice-contract-cycle';
import { uniqBy } from '../../../shared';
import { EditGrid } from '../../../shared/EditGrid';
import { SelectItem } from '../../../shared/efaact-primeng.module';
import { LoggingService } from '../../../shared/services/logging';
@Component({
    selector: 'ef-invoice-cycle',
    templateUrl: './invoice-cycle.component.html',
    styleUrls: ['./invoice-cycle.component.scss'],
    standalone: false
})
export class InvoiceCycleComponent
    extends EditGrid<InvoiceContractCycleModel>
    implements OnInit, OnChanges
{
    moment: any;
    @Input() icSelectItem: SelectItem[] = [];
    @Input() icdSelectItem: SelectItem[] = [];
    @Input() icd2SelectItem: SelectItem[] = [];
    @Input() catSelectItem: SelectItem[] = [];
    @Input() effectiveDatesSelectItem: SelectItem[] = [];
    @Input() contractSelectItems: SelectItem[];
    @Input() invoiceCycleDaysSelectItems: SelectItem[];
    @Input() invoiceCycleDay2SelectItems: SelectItem[];
    u_contractSelectItems: SelectItem[] = [];
    @Input() contractSelectItemsD2: SelectItem[] = [];
    @Input() invoiceCycle24Selected = false;
    hasInvoiceCycle24 = false;
    @Input() invoiceCycle: IInvoiceCycle[];
    @Output() ResetContract = new ReplaySubject<string>();
    endDateTooltip: string;
    invoiceCycleDays: IInvoiceCycle[];

    constructor(private log: LoggingService) {
        super();
        this.moment = moment;
    }

    ngOnInit(): void {}
    ngOnChanges(changes: SimpleChanges): void {
        this.log.verbose({
            type: 'InvoiceCycleComponent:ngOnChanges',
            changes
        });
        const value = changes.items && changes.items.currentValue;
        if (value && value.length > 0) {
            value.forEach(c => {
                if (c.InvoiceCycle != null) {
                    if (c.InvoiceCycle.toString() === '24') {
                        this.hasInvoiceCycle24 = true;
                        // this.invoicingColSpan = 6;
                    } else {
                        if (this.hasInvoiceCycle24 === false) {
                            // this.invoicingColSpan = 5;
                        }
                    }
                }
                if (c.ContractStartDate != null) {
                    c.ContractStartDate = new Date(c.ContractStartDate);
                }
                if (c.ContractEndDate != null) {
                    c.ContractEndDate = new Date(c.ContractEndDate);
                }
                if (c.CycleEffectiveDate != null) {
                    c.CycleEffectiveDate = new Date(c.CycleEffectiveDate);
                }
                if (c.FirstInvoiceStartDate != null) {
                    c.FirstInvoiceStartDate = new Date(c.FirstInvoiceStartDate);
                }
                // this.effectiveDatesSelectItem.push({
                //     value: c.CycleEffectiveDate,
                //     label: moment(c.CycleEffectiveDate).format('MM/DD/YYYY')
                // });
                // this.effectiveDatesSelectItem =
                //     this.effectiveDatesSelectItem.filter(
                //         (v, i, a) => a.findIndex(t => t.label === v.label) === i
                //     );

                if (c.InvoiceCycle != null) {
                    this.icSelectItem.push({
                        value: c.InvoiceCycle,
                        label: c.InvoiceCycle
                    });
                    this.icSelectItem = this.icSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                if (c.InvoiceCycleDay != null) {
                    const day = this.invoiceCycle.find(
                        x =>
                            x.CycleDayCode === c.InvoiceCycleDay &&
                            x.InvoiceCycle === c.InvoiceCycle
                    );
                    this.icdSelectItem.push({
                        value: c.InvoiceCycleDay,
                        label: day ? day.InvoiceCycleDay : c.InvoiceCycleDay
                    });
                    this.icdSelectItem = this.icdSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }
                if (c.InvoiceCycleDay2 != null) {
                    const day2 = this.invoiceCycle.find(
                        x =>
                            x.CycleDayCode === c.InvoiceCycleDay2 &&
                            x.InvoiceCycle === c.InvoiceCycle
                    );
                    this.icd2SelectItem.push({
                        value: c.InvoiceCycleDay2,
                        label: day2 ? day2.InvoiceCycleDay : c.InvoiceCycleDay2
                    });
                    this.icd2SelectItem = this.icd2SelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                if (c.ContractCategory != null) {
                    this.catSelectItem.push({
                        value: c.ContractCategory,
                        label: c.ContractCategory
                    });
                    this.catSelectItem = this.catSelectItem.filter(
                        (v, i, a) => a.findIndex(t => t.label === v.label) === i
                    );
                }

                // if (c.ContractListID != null) {
                //     this.contractsSelectItem.push({
                //         value: c.ContractListID,
                //         label: c.ContractDesc
                //     });
                //     this.contractsSelectItem = this.contractsSelectItem.filter(
                //         (v, i, a) => a.findIndex(t => t.label === v.label) === i
                //     );
                // }
            });

            if (!this.selected) {
                this.selected = value[0];
                this.log.verbose({
                    type: 'InvoiceCycleComponent:ngOnChanges:items',
                    items: value,
                    selected: this.selected
                });

                this.onRowSelect({
                    data: this.selected as InvoiceContractCycleModel
                });
            }
        }
        if (changes && changes.invoiceCycle) {
            const uniqueInvoiceCycles = uniqBy(
                this.invoiceCycle,
                x => x.InvoiceCycle
            );

            this.u_contractSelectItems = uniqueInvoiceCycles.map(x => ({
                label: x.InvoiceCycle == '0' ? '0' : x.InvoiceCycle,
                value: x.InvoiceCycle
            }));
        }
    }
    onRowEditInit(item: InvoiceContractCycleModel) {
        super.onRowEditInit(item);

        if (item.InvoiceCycle != null) {
            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === item.InvoiceCycle
            );
            this.invoiceCycleDaysSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
            this.selected = item;
        }
    }
    lessThanToday(endDate) {
        if (moment(endDate).toDate() < new Date()) {
            this.endDateTooltip = 'Invoicing not scheduled after Contract End';
            return true;
        } else {
            this.endDateTooltip = '';
            return false;
        }
    }
    invoiceCycleValueChanged(event) {
        // this.invoiceCycleHasBeenSelected = true;
        if (event.value === 24) {
            this.invoiceCycle24Selected = true;

            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === event.value
            );
            this.invoiceCycleDaysSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
            this.contractSelectItemsD2 = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));

            if (
                JSON.stringify(this.invoiceCycleDaysSelectItems.sort()) ===
                JSON.stringify(this.contractSelectItemsD2.sort())
            ) {
                this.contractSelectItemsD2 = this.contractSelectItemsD2.filter(
                    x => x.value !== '15'
                );
                this.invoiceCycleDaysSelectItems =
                    this.invoiceCycleDaysSelectItems.filter(
                        x => x.value !== '99'
                    );
                this.editing.InvoiceCycleDay =
                    this.invoiceCycleDaysSelectItems[0].value;
                this.editing.InvoiceCycleDay2 =
                    this.contractSelectItemsD2[0].value;
            }
            this.editing.InvoiceCycleDay =
                this.invoiceCycleDaysSelectItems[0].value;
        } else {
            this.invoiceCycle24Selected = false;
            this.invoiceCycleDays = this.invoiceCycle.filter(
                x => x.InvoiceCycle === event.value
            );
            this.invoiceCycleDaysSelectItems = this.invoiceCycleDays.map(x => ({
                label: x.InvoiceCycleDay,
                value: x.CycleDayCode
            }));
            this.editing.InvoiceCycleDay =
                this.invoiceCycleDaysSelectItems[0].value;
            if (event.value === 12) {
                this.editing.InvoiceCycleDay = '99';
            }
        }
        // this.invoiceCycleSelected = event.value;
    }
    findInvoiceDayDesc(rowData: InvoiceContractCycleModel): string {
        if (rowData.InvoiceCycleDay != null) {
            if (this.invoiceCycle.length > 0) {
                const index = this.invoiceCycle.findIndex(
                    x =>
                        x.CycleDayCode === rowData.InvoiceCycleDay &&
                        x.InvoiceCycle === rowData.InvoiceCycle
                );
                if (index !== -1) {
                    const cc = this.invoiceCycle[index];
                    return cc.InvoiceCycleDay;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }
    findInvoiceDay2Desc(rowData: InvoiceContractCycleModel): string {
        if (rowData.InvoiceCycleDay2 != null) {
            if (this.invoiceCycle.length > 0) {
                const index = this.invoiceCycle.findIndex(
                    x =>
                        x.CycleDayCode === rowData.InvoiceCycleDay2 &&
                        x.InvoiceCycle === rowData.InvoiceCycle
                );
                if (index !== -1) {
                    const cc = this.invoiceCycle[index];
                    return cc.InvoiceCycleDay;
                } else {
                    return '';
                }
            } else {
                return '';
            }
        }
    }
    tableFilter($event, type) {
        if (type == 'effectiveDate') {
            this.dataTable.filter($event.value, 'CycleEffectiveDate', 'in');
        }
        if (type == 'firstInvoiceStartDate') {
            this.dataTable.filter($event.value, 'FirstInvoiceStartDate', 'in');
        }
        if (type == 'ic') {
            this.dataTable.filter($event.value, 'InvoiceCycle', 'in');
        }
        if (type == 'icd') {
            this.dataTable.filter($event.value, 'InvoiceCycleDay', 'in');
        }
        if (type == 'icd2') {
            this.dataTable.filter($event.value, 'InvoiceCycleDay2', 'in');
        }
        if (type == 'cat') {
            this.dataTable.filter($event.value, 'ContractCategory', 'in');
        }
        if (type == 'contract') {
            this.dataTable.filter($event.value, 'ContractListID', 'in');
        }
    }
    onContractFilterChange($event) {
        this.log.verbose({
            type: 'InvoiceCycleComponent:onContractFilterChange',
            $event
        });
        this.dataTable.filter($event.value, 'ContractListID', 'in');
        const contract = this.items.find(
            x => x.ContractListID === $event.value[0]
        );
        this.log.verbose({
            type: 'InvoiceCycleComponent:onContractFilterChange',
            contract
        });
        this.selected = [contract];
        this.onRowSelect({ data: contract });
    }
}
